import logo from "../site-logo.png";

const headerData = {
  logo,
  contact: {
    phone: "+91 98765 43210",
    hours: "Open: 11AM - 11PM"
  },
  languages: [
    { code: "en", label: "English" },
    { code: "hi", label: "हिंदी" }
  ]
};

export default headerData;
